import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  header_container: {
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'space-between',
    marginBottom: '1rem',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
}));

export default useStyles;
